import Page from "framework/ui/content/Page";
import NavBar from "framework/ui/content/NavBar";
import icon from "./assets/logo.png";
import PageContent from "framework/ui/content/PageContent";
import Breadcrumbs from "framework/ui/content/Breadcrumbs";
import PageTitle from "framework/ui/content/PageTitle";
import PageSections from "framework/ui/content/PageSections";
import Copyright from "framework/ui/content/Copyright";
import './css/Gallery.css';
import './css/GuestBook.css';
import './css/NavBar.css';
import './css/PageSections.css';
import PageNavigation from "framework/ui/content/PageNavigation";

/**
 * @typedef MyPageProps
 *
 * @property {number} [pageId]  Specific page ID to display.
 */

/**
 * Component for site-specific page contents.
 *
 * @param props {MyPageProps}
 * @returns {JSX.Element}
 * @constructor
 */
export default function MyPage(props) {
  return (
    <Page {...props}>
      <NavBar icon={icon} expand={'sm'} brand={''} theme={'dark'}/>
      <PageContent>
        <Breadcrumbs/>
        <PageTitle/>
        <PageSections/>
        <PageNavigation/>
      </PageContent>
      <Copyright startYear={'1990'}/>
    </Page>
  )
}